(() => {
  const dataNode = document.querySelector('[data-ev-pdp-options]');
  if (!dataNode) return;
  const data = JSON.parse(dataNode.textContent);
  const section = document.querySelector('.product-section');
  if (!section || section.dataset.evPdpReady) return;
  section.dataset.evPdpReady = 'true';
  section.classList.add('ev-pdp-enhanced');
  const colours = {'闇夜黑':'#1c2125','極致黑':'#1c2125','經典黑':'#1c2125','黑':'#1c2125','白':'#f5f3ed','土星棕':'#745541','日蝕藍':'#253847','午夜藍':'#253348','白晝沙':'#c6b89c','卡其色':'#b9aa8b'};
  section.querySelectorAll('input[data-variant-input]').forEach(input => {
    if (!/^(顏色|color|colour)$/i.test(input.name)) return;
    const label = section.querySelector('label[for="'+CSS.escape(input.id)+'"]');
    if (!label) return;
    label.classList.add('ev-pdp-swatch');
    const sharedColour = label.style.getPropertyValue('--tz-swatch-colour').trim() || colours[input.value] || '#b9b3a8';
    label.style.setProperty('--ev-colour', sharedColour);
    label.style.setProperty('--tz-swatch-colour', sharedColour);
    label.title = input.value;
    label.textContent = input.value;
  });
  if (data.members?.length > 1) {
    const wrapper = section.querySelector('.variant-wrapper');
    if (!wrapper) return;
    const field = document.createElement('fieldset');
    field.className = 'ev-pdp-colours';
    const legend = document.createElement('legend');
    legend.textContent = '顏色';field.append(legend);
    for (const member of data.members) {
      const button = document.createElement('button');
      button.type = 'button';button.textContent = member.colour;
      button.className = 'ev-pdp-swatch';
      button.style.setProperty('--ev-colour', colours[member.colour] || '#b9b3a8');
      button.setAttribute('aria-pressed', String(member.handle === data.handle));
      button.dataset.evPdpColour = member.colour;
      button.addEventListener('click', () => {
        if (member.handle === data.handle) return;
        const selected = [...section.querySelectorAll('input[data-variant-input]:checked')].find(input => /^(尺寸|size)$/i.test(input.name))?.value;
        const variant = member.variants.find(v => v.options.includes(selected)) || member.variants.find(v => v.available) || member.variants[0];
        const url = new URL(member.url, location.origin);
        const current = new URL(location.href);
        for (const key of ['preview_theme_id','presentation','pb','review']) if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));
        if(variant)url.searchParams.set('variant',variant.id);
        location.assign(url);
      });
      field.append(button);
    }
    wrapper.before(field);
  }
})();
